/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  InputGroup,
  FormControl,
  Alert,
} from "react-bootstrap";
import {
  getAuthenticatedWebSocketUrl,
  getUserId,
} from "../../utilities/authHelper";
import { FaCopy, FaPen, FaRedo } from "react-icons/fa";
import parse, { domToReact } from "html-react-parser";
import LinkPreview from "../ProductDashboard/Emgpt/LinkPreview";
import CollapsibleDiv from "../ProductDashboard/Emgpt/CollapsibleDiv";
import HighchartFromText from "../ProductDashboard/Emgpt/HighchartFromText";
import { giveFeedback } from "../../utilities/EmgptUtilities";
import useChatVoice, { htmlToSpeechText } from "../../utilities/useChatVoice";
import { fxgptChatSuggestionsByLanguage } from "../Common/ChatSuggestions";
import ChatOverlayFrame from "../Common/ChatOverlayFrame";
import { useFxSuggestedQuestions } from "./Utilities/CoTraderUtils";
import { getStoredCoTraderLanguage } from "./Utilities/languages";
import {
  getChatSuggestionsFromPayload,
  normalizeChatSuggestion,
  normalizeChatSuggestions,
} from "../../utilities/chatSuggestionUtilities";

const VOICE_IDLE_AUTO_SEND_MS = 1000;
const EMPTY_RESPONSE_RETRY_LIMIT = 1;
const EMPTY_RESPONSE_FALLBACK_TEXT =
  "No visible response was received. Please try again.";

const CoTraderEmgptDivMobile = ({
  selectedSymbol,
  searchFlag,
  setSearchFlag,
  showSuggestions,
  selectedTickerLabel,
  setShowSuggestions,
  tabs,
  setTabs,
  useFxSuggestedQuestionsApi = false,
  // setTvTickers,
  // setActiveTvSymbol,
  // activeTvSymbol,
  isDark
}) => {
  const [messages, setMessages] = useState([]);
  const [userInput, setUserInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef(null);
  const [dynamicSuggestions, setDynamicSuggestions] = useState([]);
  const wsRef = useRef(null);
  const isCancelledRef = useRef(false);
  const [feedbackMessageId, setFeedbackMessageId] = useState([]);
  const [feedbackTexts, setFeedbackTexts] = useState({});
  const [feedbackTypes, setFeedbackTypes] = useState({});
  const [isStreaming, setIsStreaming] = useState(false);
  const [summary, setSummary] = useState("");
  const [summaryVersion, setSummaryVersion] = useState(0);
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const userLanguage = getStoredCoTraderLanguage();
  const voiceAutoSendTimerRef = useRef(null);
  const sendMessageRef = useRef(null);
  const {
    clearSpeechError,
    isListening,
    isSpeechRecognitionSupported,
    isSpeechSynthesisSupported,
    isTtsEnabled,
    resetVoiceInput,
    speakStreamingText,
    speechError,
    stopListening,
    stopSpeaking,
    toggleListening,
    toggleTts,
  } = useChatVoice({
    userInput,
    setUserInput,
    userLanguage,
  });
  const lastAnswerForSpeech = useMemo(() => {
    for (let i = messages.length - 1; i >= 0; i -= 1) {
      const message = messages[i];
      if (message?.type !== "answer") continue;
      return {
        text: message?.text || "",
        streamKey: message?.message_id || `answer-${i}`,
      };
    }
    return null;
  }, [messages]);

  // Theme
  
  const styles = useMemo(() => {
    if (isDark) {
      return {
        pageBg: "#0B0F1A",
        surface: "#12172A",
        surface2: "#0F1424",
        border: "#1E2642",
        text: "#E8ECF8",
        muted: "#A6B0CF",
        link: "#7DA0FF",
        chipBg: "#0F1424",

        // chat bubbles
        qBg: "rgba(76,125,255,0.18)",
        qBorder: "rgba(76,125,255,0.35)",
        qText: "#E8ECF8",

        aBg: "#12172A",
        aBorder: "#232B4A",
        aText: "#E8ECF8",

        // buttons
        btnBg: "#0F1424",
        btnBorder: "#232B4A",
        btnText: "#E8ECF8",

        // toast
        toastBg: "rgba(15,20,36,0.95)",
      };
    }
    return {
      pageBg: "#FFFFFF",
      surface: "#FFFFFF",
      surface2: "#FFFFFF",
      border: "#E9ECEF",
      text: "#0B1220",
      muted: "#5B6472",
      link: "#0D6EFD",
      chipBg: "#F6F7F9",

      qBg: "rgba(13,110,253,0.12)",
      qBorder: "rgba(13,110,253,0.25)",
      qText: "#0B1220",

      aBg: "#F6F7F9",
      aBorder: "#E9ECEF",
      aText: "#0B1220",

      btnBg: "#FFFFFF",
      btnBorder: "#E9ECEF",
      btnText: "#0B1220",

      toastBg: "rgba(0,0,0,0.85)",
    };
  }, [isDark]);
  const chatSurfaceVars = useMemo(
    () => ({
      "--ea-chat-page-bg": styles.pageBg,
      "--ea-chat-surface": styles.surface,
      "--ea-chat-surface-alt": isDark ? styles.surface2 : "#F7FBFF",
      "--ea-chat-border": styles.border,
      "--ea-chat-text": styles.text,
      "--ea-chat-muted": styles.muted,
      "--ea-chat-link": styles.link,
      "--ea-chat-accent": isDark ? "#4C7DFF" : "#0D6EFD",
      "--ea-chat-accent-soft": isDark
        ? "rgba(76, 125, 255, 0.18)"
        : "rgba(13, 110, 253, 0.12)",
      "--ea-chat-question-bg": isDark
        ? "linear-gradient(135deg, #3158DC 0%, #567EFF 100%)"
        : "linear-gradient(135deg, #0D6EFD 0%, #175CD3 100%)",
      "--ea-chat-question-text": "#FFFFFF",
      "--ea-chat-answer-bg": styles.aBg,
      "--ea-chat-answer-text": styles.aText,
      "--ea-chat-body-bg": isDark
        ? "linear-gradient(180deg, #0F1424 0%, #12172A 100%)"
        : "linear-gradient(180deg, #F7FBFF 0%, #FFFFFF 52%)",
      "--ea-chat-composer-bg": isDark
        ? "linear-gradient(180deg, rgba(18, 23, 42, 0.98) 0%, rgba(11, 15, 26, 1) 100%)"
        : "linear-gradient(180deg, #FBFDFF 0%, #F5F8FC 100%)",
      "--ea-chat-input-bg": isDark ? "#0F1424" : "#FFFFFF",
      "--ea-chat-chip-bg": styles.chipBg,
      "--ea-chat-ghost-bg": isDark ? "rgba(15, 20, 36, 0.78)" : "rgba(255, 255, 255, 0.88)",
      "--ea-chat-toast-bg": styles.toastBg,
      "--ea-chat-shadow": isDark
        ? "0 26px 72px rgba(0, 0, 0, 0.40)"
        : "0 22px 60px rgba(16, 24, 40, 0.10)",
    }),
    [isDark, styles]
  );

  // Mobile-specific
  const [copiedToast, setCopiedToast] = useState(false);
  const {
    suggestedQuestions,
    suggestedQuestionsError,
    suggestedQuestionsLoading,
    suggestedQuestionsMeta,
  } = useFxSuggestedQuestions({
    instrument: selectedSymbol,
    language: userLanguage,
    enabled: useFxSuggestedQuestionsApi,
  });

  const suggestionInstrumentLabel = useMemo(() => {
    if (selectedTickerLabel === null || selectedTickerLabel === undefined) {
      return selectedSymbol;
    }

    return `${selectedTickerLabel} (${selectedSymbol.replace(/^EQ-?/i, "")})`;
  }, [selectedSymbol, selectedTickerLabel]);

  const chatSuggestions = useMemo(() => {
    const useApiSuggestions =
      useFxSuggestedQuestionsApi &&
      !suggestedQuestionsError &&
      (suggestedQuestionsLoading || suggestedQuestionsMeta);
    const list = useApiSuggestions
      ? suggestedQuestions
      : fxgptChatSuggestionsByLanguage[userLanguage] ||
        fxgptChatSuggestionsByLanguage["English"];

    return normalizeChatSuggestions(list).map((suggestion) => ({
      ...suggestion,
      question: suggestion.question.replace("{symbol}", suggestionInstrumentLabel),
    }));
  }, [
    suggestedQuestions,
    suggestedQuestionsError,
    suggestedQuestionsLoading,
    suggestedQuestionsMeta,
    suggestionInstrumentLabel,
    useFxSuggestedQuestionsApi,
    userLanguage,
  ]);

  useEffect(() => {
    const el = messagesEndRef.current;
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }, [isLoading]);

  useEffect(() => {
    // cancel ongoing stream when symbol changes
    isCancelledRef.current = true;
    clearSpeechError();
    stopListening();
    stopSpeaking();
    resetVoiceInput();
    if (voiceAutoSendTimerRef.current) {
      clearTimeout(voiceAutoSendTimerRef.current);
      voiceAutoSendTimerRef.current = null;
    }

    if (wsRef.current) {
      wsRef.current.close();
      wsRef.current = null;
    }

    setIsLoading(false);
    setMessages([]);
    setDynamicSuggestions([]);
    setSummary("");
    setSummaryVersion(0);

    setTimeout(() => {
      isCancelledRef.current = false;
    }, 2);
  }, [clearSpeechError, resetVoiceInput, selectedSymbol, stopListening, stopSpeaking]);

  useEffect(() => {
    if (!isTtsEnabled || !lastAnswerForSpeech) return;
    const textForSpeech = htmlToSpeechText(lastAnswerForSpeech.text);
    speakStreamingText(textForSpeech, {
      isFinal: !isLoading,
      streamKey: lastAnswerForSpeech.streamKey,
    });
  }, [isLoading, isTtsEnabled, lastAnswerForSpeech, speakStreamingText]);

  useEffect(() => {
    return () => {
      if (voiceAutoSendTimerRef.current) {
        clearTimeout(voiceAutoSendTimerRef.current);
        voiceAutoSendTimerRef.current = null;
      }
      stopListening();
      stopSpeaking();
    };
  }, [stopListening, stopSpeaking]);

  const handleFeedback = (messageId, feedback, feedbackText) => {
    giveFeedback({
      msgId: messageId,
      feedback,
      feedbackText,
      setFeedbackMessageId,
    });
  };

  const handleFeedbackTextChange = (messageId, text) => {
    setFeedbackTexts((prev) => ({ ...prev, [messageId]: text }));
  };

  const clearPendingFeedback = (messageId) => {
    setFeedbackTexts((prev) => {
      const updated = { ...prev };
      delete updated[messageId];
      return updated;
    });
    setFeedbackTypes((prev) => {
      const updated = { ...prev };
      delete updated[messageId];
      return updated;
    });
  };

  const openFeedbackForm = (messageId, feedbackType) => {
    setFeedbackTypes((prev) => ({ ...prev, [messageId]: feedbackType }));
    setFeedbackTexts((prev) => ({ ...prev, [messageId]: "" }));
  };

  const submitFeedback = (messageId) => {
    const feedback = feedbackTypes[messageId] || "Negative";
    const feedbackText = feedbackTexts[messageId]?.trim() || feedback;
    handleFeedback(messageId, feedback, feedbackText);
    clearPendingFeedback(messageId);
  };

  const getFeedbackPlaceholder = (messageId) =>
    feedbackTypes[messageId] === "Positive"
      ? "Tell us what worked well..."
      : "Tell us what went wrong...";

  const handleInputChange = (e) => setUserInput(e.target.value);

  const handleSendMessage = async ({
    userInput,
    evidenceRefs = [],
    silentRetry = false,
    preservedContext = null,
    retryCount = 0,
  }) => {
    try {
      clearSpeechError();
      stopListening();
      stopSpeaking();
      if (voiceAutoSendTimerRef.current) {
        clearTimeout(voiceAutoSendTimerRef.current);
        voiceAutoSendTimerRef.current = null;
      }
      setDynamicSuggestions([]);
      const trimmedInput = (userInput || "").trim();
      if (!trimmedInput) return;
      const normalizedEvidenceRefs = Array.isArray(evidenceRefs)
        ? evidenceRefs
        : [];

      setIsLoading(true);
      resetVoiceInput();

      const newMessage = { type: "question", text: trimmedInput };

      if (!silentRetry) {
        setMessages((prev) => [...prev, newMessage]);
      }

      const lastQAContext =
        typeof preservedContext === "string"
          ? preservedContext
          : messages
              .filter((msg) => msg.type === "question" || msg.type === "answer")
              .slice(-4)
              .map(
                (msg) =>
                  `${msg.type === "question" ? "Question:" : "Answer:"} ${msg.text}`
              )
              .join(" ") || "";

      if (!silentRetry) {
        setMessages((prev) => [...prev, { type: "answer", text: "" }]);
      }

      const user_id = getUserId();
      const random_number = Math.floor(100000 + Math.random() * 900000);
      const chat_id = `FXGPT-${user_id}-${random_number}`;
      const user_language = getStoredCoTraderLanguage();

      const requestBody = {
        query: `question: ${newMessage.text}`,
        context: lastQAContext,
        document_id: [""],
        dashboard_name: "",
        countries: [""],
        company_ids: [selectedSymbol],
        reference_ids: "",
        evidence_refs: normalizedEvidenceRefs,
        timestamp: new Date().toISOString(),
        chat_id: chat_id,
        sender: user_id,
        sender_display_name: "USER",
        userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        search_flag: searchFlag,
        show_messages: false,
        origin: "FXGPT",
        show_suggestions: showSuggestions,
        summary: summary,
        summary_version: summaryVersion,
        user_language: user_language,
      };

      let rafId = null;
      let streamBuf = "";

      const flushAnswerOncePerFrame = () => {
        if (!streamBuf) return;
        const chunk = streamBuf;
        streamBuf = "";

        setMessages((prev) => {
          if (!prev.length) return prev;
          const updated = [...prev];
          for (let i = updated.length - 1; i >= 0; i--) {
            if (updated[i]?.type === "answer") {
              const prevText = updated[i].text || "";
              updated[i] = { ...updated[i], text: prevText + chunk };
              break;
            }
          }
          return updated;
        });
      };

      const scheduleFrameFlush = () => {
        if (rafId !== null) return;
        rafId = requestAnimationFrame(() => {
          rafId = null;
          flushAnswerOncePerFrame();
        });
      };

      const enqueueText = (s) => {
        if (!s) return;
        streamBuf += s;
        scheduleFrameFlush();
      };

      let wsBurstTimer = null;
      let wsBurstBuf = "";

      const addToBurst = (s) => {
        if (!s) return;
        wsBurstBuf += s;
        if (wsBurstTimer) return;
        wsBurstTimer = setTimeout(() => {
          enqueueText(wsBurstBuf);
          wsBurstBuf = "";
          wsBurstTimer = null;
        }, 25);
      };

      let reconnectEnabled = true;
      let hasFinished = false;
      let reconnectAttempts = 0;
      const MAX_RECONNECT_ATTEMPTS = 5;
      let lastType = null;
      let activeAssistantMessageId = null;
      let hasRenderableContent = false;

      const applyEmptyResponseFallback = () => {
        setMessages((prev) => {
          if (!prev.length) return prev;
          const updated = [...prev];
          for (let i = updated.length - 1; i >= 0; i -= 1) {
            if (updated[i]?.type === "answer") {
              const currentText = updated[i]?.text || "";
              if (currentText.trim()) {
                return prev;
              }
              updated[i] = {
                ...updated[i],
                text: EMPTY_RESPONSE_FALLBACK_TEXT,
              };
              return updated;
            }
          }
          return prev;
        });
      };

      const resetReplayState = () => {
        if (wsBurstTimer) {
          clearTimeout(wsBurstTimer);
          wsBurstTimer = null;
        }
        if (rafId !== null) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
        wsBurstBuf = "";
        streamBuf = "";
        lastType = null;
        setIsStreaming(false);
        setMessages((prev) => {
          if (!prev.length) return prev;
          const updated = [...prev];
          for (let i = updated.length - 1; i >= 0; i -= 1) {
            if (updated[i]?.type === "answer") {
              updated[i] = { ...updated[i], text: "" };
              return updated;
            }
          }
          return prev;
        });
      };

      const stopAll = () => {
        reconnectEnabled = false;
        try {
          wsRef.current?.close();
        } catch {}
        if (wsBurstTimer) {
          clearTimeout(wsBurstTimer);
          wsBurstTimer = null;
        }
        flushAnswerOncePerFrame();
        setIsLoading(false);
        setIsStreaming(false);
        if (typeof isCancelledRef?.current !== "undefined") {
          isCancelledRef.current = false;
        }
      };

      const scheduleReconnect = () => {
        if (!reconnectEnabled || hasFinished || isCancelledRef?.current) return;
        if (!activeAssistantMessageId) {
          console.warn("Reconnect skipped because no active assistant message_id is available yet.");
          stopAll();
          return;
        }
        if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
          stopAll();
          return;
        }
        const delay = Math.min(1000 * Math.pow(2, reconnectAttempts), 10000);
        reconnectAttempts += 1;
        setTimeout(() => {
          void connectWS(true).catch((error) => {
            console.error("WebSocket reconnect auth/setup error:", error);
            if (!isCancelledRef?.current) {
              scheduleReconnect();
            }
          });
        }, delay);
      };

      const connectWS = async (isReconnect = false) => {
        if (!reconnectEnabled || hasFinished || isCancelledRef?.current) return;

        const wsUrl = await getAuthenticatedWebSocketUrl(
          chat_id,
          user_id,
          isReconnect ? activeAssistantMessageId : undefined
        );
        const ws = new WebSocket(wsUrl);
        wsRef.current = ws;

        ws.onopen = () => {
          if (isReconnect) {
            resetReplayState();
            return;
          }
          ws.send(JSON.stringify(requestBody));
        };

        ws.onmessage = (event) => {
          if (isCancelledRef?.current) {
            stopAll();
            return;
          }

          try {
            const data = JSON.parse(event.data);
            activeAssistantMessageId =
              data?.message_id ||
              (data.type === "MESSAGE_ID" && data.message != null
                ? String(data.message)
                : activeAssistantMessageId);

            if (data.message) {
              if (data.type === "CHART" && lastType !== "CHART")
                addToBurst("<chartrender>");
              else if (lastType === "CHART" && data.type !== "CHART")
                addToBurst("</chartrender>");

              if (data.type === "YAHOO_FINANCE_TICKERS") {
                if (
                  data.message !== "False" &&
                  !tabs.find((tab) => tab.tvSymbol === data.message)
                ) {
                  setTabs((t) => [
                    ...t,
                    {
                      id: data.message,
                      label: data.message,
                      tvSymbol: data.message,
                    },
                  ]);
                  // setTvTickers((tickers) => [data.message, ...tickers]);
                }
                return;
              }

              if (data.type === "SUMMARY_UPDATE") {
                const summaryPayload =
                  typeof data.message === "string"
                    ? JSON.parse(data.message)
                    : data.message;
                setSummary(summaryPayload?.summary || "");
                setSummaryVersion(summaryPayload?.version || 0);
                return;
              }

              if (data.type === "INFO" && lastType !== "INFO") {
                addToBurst("<CollapsibleDiv>");
                setIsStreaming(true);
              } else if (data.type !== "INFO" && lastType === "INFO") {
                setIsStreaming(false);
                addToBurst("</CollapsibleDiv>");
              }

              if (data.type === "urls") {
                hasRenderableContent = true;
                const urls = data.message.split(" ");
                const finalString =
                  `<div className="d-flex flex-row gap-3 overflow-x-auto w-full p-2 rounded-lg bg-muted shadow-sm">` +
                  urls
                    .map(
                      (url) =>
                        `<div key=${url} className="min-w-[250px] max-w-[350px] flex-shrink-0"><LinkPreview url=${url}></LinkPreview></div>`
                    )
                    .join("") +
                  `</div><br /><br /><br />`;
                addToBurst(finalString);
              } else if (data.type === "SUGGESTIONS") {
                setDynamicSuggestions(getChatSuggestionsFromPayload(data.message));
              } else if (data.type !== "MESSAGE_ID") {
                if (
                  typeof data.message === "string" &&
                  data.message.trim().length > 0
                ) {
                  hasRenderableContent = true;
                }
                addToBurst(data.message);
              }

              lastType = data.type || null;
            }

            if (data.type === "MESSAGE_ID") {
              setMessages((prev) => {
                const updated = [...prev];
                for (let i = updated.length - 1; i >= 0; i--) {
                  if (updated[i]?.type === "answer") {
                    updated[i] = { ...updated[i], message_id: data.message };
                    break;
                  }
                }
                return updated;
              });
            }

            if (data.type === "FINISH") {
              hasFinished = true;
              reconnectEnabled = false;
              activeAssistantMessageId = null;

              if (wsBurstTimer) {
                clearTimeout(wsBurstTimer);
                wsBurstTimer = null;
                enqueueText(wsBurstBuf);
                wsBurstBuf = "";
              }

              flushAnswerOncePerFrame();
              if (!hasRenderableContent) {
                if (retryCount < EMPTY_RESPONSE_RETRY_LIMIT) {
                  console.warn(
                    "CoTrader mobile chat received an empty assistant response; retrying once."
                  );
                  try {
                    ws.close();
                  } catch {}
                  window.setTimeout(() => {
                    sendMessageRef.current?.({
                      userInput: trimmedInput,
                      evidenceRefs: normalizedEvidenceRefs,
                      silentRetry: true,
                      preservedContext: lastQAContext,
                      retryCount: retryCount + 1,
                    });
                  }, 0);
                  return;
                }

                applyEmptyResponseFallback();
              }
              try {
                ws.close();
              } catch {}
              setIsLoading(false);
              return;
            }
          } catch (err) {
            console.error("WS parse error:", err);
          }
        };

        ws.onerror = (err) => console.error("WebSocket error:", err);

        ws.onclose = () => {
          if (!hasFinished && !isCancelledRef?.current && reconnectEnabled)
            scheduleReconnect();
          else if (typeof isCancelledRef?.current !== "undefined")
            isCancelledRef.current = false;
        };
      };

      await connectWS();
    } catch (error) {
      console.error("handleSendMessage error:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    sendMessageRef.current = handleSendMessage;
  }, [handleSendMessage]);

  useEffect(() => {
    if (voiceAutoSendTimerRef.current) {
      clearTimeout(voiceAutoSendTimerRef.current);
      voiceAutoSendTimerRef.current = null;
    }

    if (!isListening || isLoading) return;
    const trimmedVoiceInput = (userInput || "").trim();
    if (!trimmedVoiceInput) return;

    voiceAutoSendTimerRef.current = setTimeout(() => {
      stopListening();
      sendMessageRef.current?.({ userInput: trimmedVoiceInput });
      voiceAutoSendTimerRef.current = null;
    }, VOICE_IDLE_AUTO_SEND_MS);

    return () => {
      if (voiceAutoSendTimerRef.current) {
        clearTimeout(voiceAutoSendTimerRef.current);
        voiceAutoSendTimerRef.current = null;
      }
    };
  }, [isListening, isLoading, stopListening, userInput]);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") handleSendMessage({ userInput });
  };

  const handleSuggestionClick = (suggestion) => {
    const normalizedSuggestion = normalizeChatSuggestion(suggestion);
    if (!normalizedSuggestion) return;

    setUserInput(normalizedSuggestion.question);
    handleSendMessage({
      userInput: normalizedSuggestion.question,
      evidenceRefs: normalizedSuggestion.evidence_refs,
    });
  };

  const copyToClipboard = async (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    const plainText = doc.body.textContent || "";

    try {
      await navigator.clipboard.writeText(plainText);
      setCopiedToast(true);
      setTimeout(() => setCopiedToast(false), 1200);
    } catch (e) {
      console.error("Clipboard error", e);
    }
  };

  const regenerateAnswer = (index, realTime) => {
    setSearchFlag(realTime);
    const questionToRegenerate = messages[index - 1]?.text || "";
    handleSuggestionClick(questionToRegenerate);
  };

  const ClearChat = () => {
    clearSpeechError();
    stopListening();
    stopSpeaking();
    resetVoiceInput();
    if (voiceAutoSendTimerRef.current) {
      clearTimeout(voiceAutoSendTimerRef.current);
      voiceAutoSendTimerRef.current = null;
    }
    setMessages([]);
    setFeedbackTexts({});
    setFeedbackTypes({});
    setTabs([]);
    setSummary("");
    setSummaryVersion(0);
  };

  // Mobile: open TradingView sheet when activeTvSymbol is set
  // useEffect(() => {
  //   if (activeTvSymbol) setShowTvSheet(true);
  // }, [activeTvSymbol]);

  // const closeTvSheet = () => {
  //   setShowTvSheet(false);
  //   setActiveTvSymbol(null);
  // };

  return (
    <ChatOverlayFrame
      isOpen={isOverlayOpen}
      onClose={() => setIsOverlayOpen(false)}
    >
      <div
        className="w-100 h-100 d-flex flex-column pb-10 ea-chat-surface ea-chat-shell"
        style={{ ...chatSurfaceVars, background: styles.pageBg }}
      >
      {/* Sticky top bar */}
      <div
        className="ea-chat-header px-2 py-2 d-flex align-items-center justify-content-between gap-3 flex-wrap"
        style={{
          position: "sticky",
          top: 0,
          zIndex: 20,
          background: styles.surface,
        }}
      >
        <div className="ea-chat-title-group">
          <div className="ea-chat-title" style={{ fontSize: "1rem", color: styles.text }}>
            FX GPT
          </div>
          <p className="ea-chat-subtitle mb-0">
            Tracking {selectedTickerLabel || selectedSymbol} with live market context.
          </p>
        </div>

        <div className="ea-chat-header-actions">
          <Button
            type="button"
            onClick={() => setIsOverlayOpen((prev) => !prev)}
            className="btn btn-sm ea-chat-ghost-btn"
            title={isOverlayOpen ? "Exit full screen" : "Open full screen"}
            aria-pressed={isOverlayOpen}
          >
            <i
              className={`fa-solid ${
                isOverlayOpen ? "fa-compress" : "fa-expand"
              } me-2`}
            />
            {isOverlayOpen ? "Exit" : "Expand"}
          </Button>
          {messages.length > 0 && (
            <Button
              onClick={ClearChat}
              className="btn btn-sm ea-chat-clear-btn"
              disabled={isLoading}
            >
              Clear
            </Button>
          )}
        </div>
      </div>

      <div className="overflow-auto flex-1 d-flex flex-column flex-grow-1">
        {/* Tabs row (tickers) – horizontal scroll for mobile */}
        {/* {tabs?.length > 0 && (
          <div
            className="px-2 py-2"
            style={{ borderBottom: `1px solid ${styles.border}` }}
          >
            <div style={{ color: styles.muted, fontSize: "0.8rem" }} className="mb-1">
              Tickers in chat:
            </div>
            <Nav variant="pills" className="flex-nowrap overflow-auto">
              {tabs.map((t) => {
                const isActive = activeTvSymbol === t.tvSymbol;
                return (
                  <Nav.Item key={t.id} className="me-2">
                    <Nav.Link
                      active={isActive}
                      onClick={() => setActiveTvSymbol(isActive ? null : t.tvSymbol)}
                      style={{
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                        background: isActive ? styles.qBg : styles.chipBg,
                        border: `1px solid ${isActive ? styles.qBorder : styles.border}`,
                        color: styles.text,
                      }}
                    >
                      {t.label}
                    </Nav.Link>
                  </Nav.Item>
                );
              })}
            </Nav>
          </div>
        )} */}

        {/* ✅ ONLY scroll container */}
        <div
          className="flex-grow-1 overflow-auto px-2 py-2 ea-chat-scroll"
          style={{ minHeight: 0, WebkitOverflowScrolling: "touch" }}
        >
          {/* Toast-ish */}
          {copiedToast && (
            <div
              className="position-fixed start-50 translate-middle-x text-white px-3 py-2 ea-chat-toast"
              style={{
                bottom: 88,
                zIndex: 9999,
                fontSize: "0.85rem",
              }}
            >
              Copied
            </div>
          )}

          {/* Suggestions when empty */}
          {messages.length === 0 ? (
            <div className="ea-chat-empty" style={{ background: styles.pageBg }}>
              <div className="row g-2">
                {chatSuggestions.map((suggestion, index) => (
                  <div className="col-6" key={`${suggestion.question}-${index}`}>
                    <Button
                      className="w-100 ea-chat-suggestion-btn"
                      onClick={() => handleSuggestionClick(suggestion)}
                      style={{
                        fontSize: "12px",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "normal",
                        lineHeight: "1.3em",
                        height: "3.3em",
                      }}
                    >
                      {suggestion.question}
                    </Button>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <>
              {messages.map((msg, index) => {
                const isQ = msg.type === "question";
                return (
                <Alert
                  key={index}
                  className={`my-2 ea-chat-bubble ${
                    isQ ? "ea-chat-bubble--question" : "ea-chat-bubble--answer"
                  }`}
                  style={{
                    maxWidth: isQ ? "92%" : "100%",
                    marginLeft: isQ ? "auto" : "0",
                  }}
                >
                    <div className="ea-chat-rich">
                      <RenderFromString
                        htmlString={msg.text}
                        isStreaming={
                          isStreaming &&
                          msg.type === "answer" &&
                          index === messages.length - 1
                        }
                      />
                    </div>

                    {msg.type === "answer" && !isLoading && (
                      <>
                        <div className="ea-chat-actions">
                          {/* feedback */}
                          <div className="ea-chat-action-group">
                            {msg.message_id &&
                              !feedbackMessageId.includes(msg.message_id) && (
                                <>
                                  <Button
                                    className="ea-chat-icon-btn"
                                    variant="outline-success"
                                    size="sm"
                                    onClick={() =>
                                      openFeedbackForm(msg.message_id, "Positive")
                                    }
                                  >
                                    <i className="fa-solid fa-thumbs-up" />
                                  </Button>

                                  <Button
                                    className="ea-chat-icon-btn"
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={() =>
                                      openFeedbackForm(msg.message_id, "Negative")
                                    }
                                  >
                                    <i className="fa-solid fa-thumbs-down" />
                                  </Button>
                                </>
                              )}
                          </div>

                          {/* actions */}
                          <div className="ea-chat-action-group ms-auto" style={{ color: styles.text }}>
                            <span
                              className="ea-chat-action-link"
                              role="button"
                              tabIndex={0}
                              onClick={() => copyToClipboard(msg.text)}
                              onKeyDown={(event) => {
                                if (event.key === "Enter" || event.key === " ") {
                                  event.preventDefault();
                                  copyToClipboard(msg.text);
                                }
                              }}
                              title="Copy"
                            >
                              <FaCopy aria-hidden="true" />
                            </span>
                            <span
                              className="ea-chat-action-link"
                              role="button"
                              tabIndex={0}
                              title="Edit"
                              onClick={() => {
                                setUserInput(messages[index - 1]?.text || "");
                                document.getElementById("userInputMobile")?.focus();
                              }}
                              onKeyDown={(event) => {
                                if (event.key === "Enter" || event.key === " ") {
                                  event.preventDefault();
                                  setUserInput(messages[index - 1]?.text || "");
                                  document.getElementById("userInputMobile")?.focus();
                                }
                              }}
                            >
                              <FaPen aria-hidden="true" />
                            </span>
                            <span
                              className="ea-chat-action-link"
                              role="button"
                              tabIndex={0}
                              title="Regenerate"
                              onClick={() => regenerateAnswer(index, searchFlag)}
                              onKeyDown={(event) => {
                                if (event.key === "Enter" || event.key === " ") {
                                  event.preventDefault();
                                  regenerateAnswer(index, searchFlag);
                                }
                              }}
                            >
                              <FaRedo aria-hidden="true" />
                            </span>
                          </div>
                        </div>
                      </>
                    )}

                    {/* Feedback textarea */}
                    {feedbackTexts[msg.message_id] !== undefined && (
                      <div className="mt-2 w-100">
                        <FormControl
                          className="ea-chat-feedback-textarea"
                          as="textarea"
                          rows={2}
                          placeholder={getFeedbackPlaceholder(msg.message_id)}
                          value={feedbackTexts[msg.message_id]}
                          onChange={(e) =>
                            handleFeedbackTextChange(msg.message_id, e.target.value)
                          }
                        />
                        <Button
                          size="sm"
                          className="mt-1 ea-chat-feedback-submit"
                          onClick={() => {
                            submitFeedback(msg.message_id);
                          }}
                        >
                          Submit
                        </Button>
                      </div>
                    )}
                  </Alert>
                );
              })}

              {/* Dynamic suggestions */}
              {dynamicSuggestions.length > 0 && !isLoading && (
                <div className="mt-2">
                  <div className="row g-2">
                    {dynamicSuggestions.map((suggestion, index) => (
                      <div
                        className="col-6"
                        key={`${suggestion.question}-${index}`}
                      >
                        <Button
                          className="w-100 ea-chat-suggestion-btn"
                          onClick={() => handleSuggestionClick(suggestion)}
                          style={{
                            fontSize: "12px",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "normal",
                            lineHeight: "1.3em",
                            height: "3.3em",
                          }}
                        >
                          {suggestion.question}
                        </Button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Loading dots */}
              {isLoading && (
                <div className="d-flex justify-content-start my-2">
                  <div
                    className="px-3 py-2 rounded d-flex flex-row justify-content-center ea-chat-loading-bubble"
                    style={{
                      width: "140px",
                    }}
                  >
                    <div className="loading-dot"></div>
                    <div className="loading-dot"></div>
                    <div className="loading-dot"></div>
                  </div>
                </div>
              )}

              <div ref={messagesEndRef} />
            </>
          )}
        </div>
      </div>

      {/* Sticky input bar */}
      <div
        className="px-2 py-2 ea-chat-composer"
        style={{
          position: "sticky",
          bottom: 0,
          zIndex: 20,
          background: styles.surface,
          color: styles.text,
        }}
      >
        {speechError && (
          <div className="pb-1" style={{ fontSize: "12px", color: isDark ? "#F6B0B0" : "#B42318" }}>
            {speechError}
          </div>
        )}
        {isListening && !isLoading && (
          <div className="pb-1" style={{ fontSize: "12px", color: styles.muted }}>
            Listening... auto-send after {VOICE_IDLE_AUTO_SEND_MS / 1000}s of silence.
          </div>
        )}
        <InputGroup className="ea-chat-composer-row">
          <FormControl
            type="text"
            placeholder="Type your question"
            className={`${isDark ? "dark-input" : ""} ea-chat-input`}
            id="userInputMobile"
            value={userInput}
            onChange={handleInputChange}
            onKeyDown={handleKeyPress}
            disabled={isLoading}
            autoComplete="off"
          />
          <Button
            className="ea-chat-icon-btn"
            onClick={toggleListening}
            title={isListening ? "Stop voice input" : "Start voice input"}
            aria-label={isListening ? "Stop voice input" : "Start voice input"}
            aria-pressed={isListening}
            disabled={isLoading || !isSpeechRecognitionSupported}
            variant="outline-secondary"
            style={{
              color: isListening ? "#DC3545" : styles.text,
              opacity: isSpeechRecognitionSupported ? 1 : 0.55,
            }}
          >
            <i
              className={`fa-solid ${isListening ? "fa-microphone-slash" : "fa-microphone"}`}
            />
          </Button>
          <Button
            className="ea-chat-icon-btn"
            onClick={toggleTts}
            title={isTtsEnabled ? "Disable voice output" : "Enable voice output"}
            aria-label={isTtsEnabled ? "Disable voice output" : "Enable voice output"}
            aria-pressed={isTtsEnabled}
            disabled={!isSpeechSynthesisSupported}
            variant="outline-secondary"
            style={{
              color: isTtsEnabled ? "#198754" : styles.text,
              opacity: isSpeechSynthesisSupported ? 1 : 0.55,
            }}
          >
            <i
              className={`fa-solid ${isTtsEnabled ? "fa-volume-high" : "fa-volume-xmark"}`}
            />
          </Button>

          {isLoading ? (
            <Button
              className="ea-chat-icon-btn"
              onClick={() => {
                stopListening();
                stopSpeaking();
                if (wsRef.current) {
                  wsRef.current.close();
                  wsRef.current = null;
                }
                setIsLoading(false);
                setIsStreaming(false);
              }}
              variant="outline-secondary"
              style={{
                color: styles.text,
              }}
            >
              <i className="fa fa-stop" aria-hidden="true"></i>
            </Button>
          ) : (
            <Button
              className="ea-chat-send-btn"
              onClick={() => handleSendMessage({ userInput })}
            >
              Send
            </Button>
          )}
        </InputGroup>
      </div>

      {/* TradingView as mobile bottom sheet */}
      {/* <Offcanvas
        show={showTvSheet}
        onHide={closeTvSheet}
        placement="bottom"
        style={{
          height: "88%",
          background: styles.pageBg,
          borderTop: `1px solid ${styles.border}`,
        }}
      >
        <Offcanvas.Header closeButton style={{ borderBottom: `1px solid ${styles.border}` }}>
          <Offcanvas.Title style={{ color: styles.text }}>
            {activeTvSymbol || "Chart"}
          </Offcanvas.Title>
          <style>{`
            .offcanvas-header .btn-close { filter: ${isDark ? "invert(1)" : "none"}; }
          `}</style>
        </Offcanvas.Header>
        <Offcanvas.Body style={{ padding: 0 }}>
          <div style={{ width: "100%", height: "100%" }}>
            {activeTvSymbol && (
              <TradingViewChart symbol={activeTvSymbol} dark={isDark} />
            )}
          </div>
        </Offcanvas.Body>
      </Offcanvas> */}
      </div>
    </ChatOverlayFrame>
  );
};

export default CoTraderEmgptDivMobile;

export const RenderFromString = ({ htmlString, isStreaming }) => {
  if (typeof htmlString !== "string") {
    console.error("RenderFromString expects a string but received:", htmlString);
    return null;
  }

  return parse(htmlString, {
    replace: (domNode) => {
      if (domNode.name === "linkpreview") {
        const url = domNode.attribs?.url || "#";
        return <LinkPreview url={url} />;
      }
      if (domNode.name === "collapsiblediv") {
        return (
          <CollapsibleDiv isStreaming={isStreaming}>
            {domToReact(domNode.children)}
          </CollapsibleDiv>
        );
      }
      if (domNode.name === "chartrender") {
        return (
          <HighchartFromText chartText={domNode.childNodes?.[0]?.data || ""} />
        );
      }
    },
  });
};
